<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
  
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="mb-2 float-end">
                <b-button v-b-modal.new-unit size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Item Unit</b-button>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(product)="data">
                  {{ data.item.product.name }}
                </template>
                <template #cell(unit)="data">
                  {{ data.item.unit.unit_name }}
                </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                  <b-button @click="edit(data.item.id,data.item.product.id,data.item.unit.id,data.item.buyingprice,data.item.sellingprice,data.item.base_quantity )" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                  <b-button @click="remove(data.item.id,data.item.product.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                  </div>
                </template>
                </b-table>
                <div class="total-payments">
                  <strong>Total BuyingPrice:</strong> {{ commas(totalbuyingprice) }}
                  <span class="horizontal-separator">  </span>
                  <strong>Total SellingPrice:</strong> {{ commas(totalsellingprice) }}
                  
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <b-modal id="new-unit" centered title="New Item Unit" title-class="font-18" hide-footer>
          <form @submit.prevent="addUnit">
            <div class="form-group mb-2">
              <label>Product</label>
              <b-form-select v-model="product" required :options="products" class="mb-3 form-control" value-field="id" text-field="name"></b-form-select>
              </div>
              <div class="form-group mb-2">
              <label>Unit</label>
              <b-form-select v-model="unit" required :options="productunits" class="mb-3 form-control" value-field="id" text-field="name"></b-form-select>
              </div>
              <div class="form-group mb-2">
              <label>Selling Price</label>
              <input v-model="sellingprice" type="number" required class="form-control" />
              </div>
              <div class="form-group mb-2">
              <label>Buying Price</label>
              <input v-model="buyingprice" type="number" required class="form-control" />
              </div>
              <div class="form-group mb-2">
              <label>Base Quantity</label>
              <input v-model="base_quantity" type="number" required class="form-control" />
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-unit')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="edit-unit" centered title="Edit Item Unit" title-class="font-14" hide-footer>
          <form @submit.prevent="editUnit">
              <div class="form-group mb-2">
              <input v-model="id" type="hidden">
              <label>Product</label>
              <b-form-select v-model="product" required :options="products" class="mb-3 form-control" value-field="id" text-field="name"></b-form-select>
              </div>
              <div class="form-group mb-2">
              <label>Unit</label>
              <b-form-select v-model="unit" required :options="productunits" class="mb-3 form-control" value-field="id" text-field="name"></b-form-select>
              </div>
              <div class="form-group mb-2">
              <label>Buying Price</label>
              <input v-model="buyingprice" type="number" required class="form-control" />
              </div>
              <div class="form-group mb-2">
              <label>Selling Price</label>
              <input v-model="sellingprice" type="number" required class="form-control" />
              </div>
              <div class="form-group mb-2">
              <label>Base Quantity</label>
              <input v-model="base_quantity" type="number" required class="form-control" />
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-unit')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="delete-unit" centered title="Delete Item Unit" title-class="font-18" hide-footer>
          <form @submit.prevent="removeUnit">
              <input v-model="id" type="hidden">
                Are you sure you want to delete the Item Unit : <b>{{ product }}</b> ?
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-unit')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
              </div>
          </form>
      </b-modal>
  
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  import Layout from "../../layouts/main";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import { unitsMethods , productMethods,itemunitsMethods, itemunitsComputed,unitsComputed, productComputed } from "@/state/helpers";
  
  export default {
    page: {
      title: "Product Item Units",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader
    },
    data() {
      return {
        title: "Product Item Units",
        items: [ {text: "Dashboard",to: "/",}, {text: "Product Item Units",active: true, }, ],
        TotalRows: 1,
        currentPage: 1,
        perPage: 10,
        Options: [10, 50, 100, 150, 200],
        filter: null,
        todoFilter: null,
        filterOn: [],
        sortDesc: true,
        isBusy: true,
        fields: [
            { key: 'index', label: '#', visible: true },
            { key: 'id', label: 'ID', visible: false },
            { key: 'product', label: 'Product Name', visible: true },
            { key: 'unit', label: 'Unit Name', visible: true },
            { key: 'buyingprice', label: 'Buying Price', visible: true },
            { key: 'sellingprice', label: 'Selling Price', visible: true },
            { key: 'base_quantity', label: 'Base Quantity', visible: true },
            { key: 'addedby', label: 'Added by', visible: true },
            { key: 'addedon', label: 'Added on', visible: true },
            { key: 'actions', label: 'Actions', visible: true },
          ],
        id:'',
        product:'',
        unit:'',
        buyingprice:'',
        sellingprice:'',
        base_quantity:'',
      };
    },
    computed: {
      ...itemunitsComputed,
      ...unitsComputed,
      ...productComputed,
      List() { return this.productitemunits.length; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.productitemunits.map((d) => ({...d }))},
      IsBusy() { let a=false; if (this.productitemunits.length>0) { a=false;} else { a=true;} return a },
      totalbuyingprice() { return this.productitemunits.reduce((total, item) => total + Number(item.buyingprice), 0); },
      totalsellingprice() { return this.productitemunits.reduce((total, item) => total + Number(item.sellingprice), 0); },

    },
    mounted() {
      this.fetchItemUnits();
      this.fetchUnits();
      this.fetchProducts();
      this.TotalRows = this.productitemunits.length;
      this.isBusy=false;
    },
    methods: {
      ...itemunitsMethods,
      ...productMethods,
      ...unitsMethods,
      commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },

      Filtered(filteredItems) {
        this.TotalRows = filteredItems.length;
        this.currentPage = 1;
      },
      edit(id,product,unit,buyingprice,sellingprice,base_quantity){
        this.id=id;
        this.product=product;
        this.unit=unit;
        this.sellingprice=sellingprice;
        this.buyingprice=buyingprice;
        this.base_quantity=base_quantity;
        this.$bvModal.show('edit-unit')
      },
      remove(id,product){
        this.id=id;
        this.product=product;
        this.$bvModal.show('delete-unit')
      },
      async addUnit() { 
        let formData = new FormData();
        formData.append("product", this.product);
        formData.append("unit", this.unit);
        formData.append("sellingprice", this.sellingprice);
        formData.append("buyingprice", this.buyingprice);
        formData.append("base_quantity", this.base_quantity);
        let url = "/recordproductunit";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.fetchItemUnits();
            this.$bvModal.hide('new-unit');
            this.product="";
            this.unit="";
            this.sellingprice="";
            this.buyingprice="";
            this.base_quantity="";
        }
        });
      },
      async editUnit(){ 
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("product", this.product);
      formData.append("unit", this.unit);
      formData.append("sellingprice", this.sellingprice);
      formData.append("buyingprice", this.buyingprice);
      formData.append("base_quantity", this.base_quantity);
      let url = "/editproductunit";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchItemUnits();
          this.$bvModal.hide('edit-unit');
          this.product="";
            this.unit="";
            this.sellingprice="";
            this.buyingprice="";
            this.base_quantity="";
        }
      });
      },
      async removeUnit() { 
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/deleteproductunit";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchItemUnits();
          this.$bvModal.hide('delete-unit');
        }
      });
      },
    },
  };
  </script>
  <style scoped>
  .horizontal-separator {
    margin: 0 15px; 
  }
  </style>